/** @jsxImportSource @emotion/react */

import css from '@emotion/css/macro'
import type { EmotionJSX } from '@emotion/react/types/jsx-namespace'
import { Button as AntButton } from 'antd'
import LoadingSpinner from '../LoadingSpinner'

interface Props {
  variant?: 'primary' | 'secondary'
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  label: string
  icon?: React.ReactNode | JSX.Element | EmotionJSX.Element
  disabled?: boolean
  isLoading?: boolean
  small?: boolean
  labelColor?: string
  useAltFontFamily?: boolean
  id?: string
  useReturnKey?: boolean
  type?: 'button' | 'submit' | 'reset'
  tabIndex?: number
}

export const Button = ({
  variant = 'primary',
  onClick,
  label,
  icon,
  disabled,
  isLoading,
  small,
  labelColor,
  useAltFontFamily,
  id,
  type,
  tabIndex,
}: Props) => {
  return (
    <AntButton
      tabIndex={tabIndex}
      htmlType={type}
      id={id}
      disabled={disabled}
      onClick={onClick}
      icon={icon}
      css={css`
        width: 100%;
        padding: ${small ? '6px' : '8px'};
        gap: ${small ? '6px' : '8px'};
        align-items: center;
        display: flex;
        justify-content: space-around;
      `}
      type={
        variant === 'primary'
          ? 'primary'
          : variant === 'secondary'
          ? 'default'
          : 'dashed'
      }
    >
      {isLoading ? (
        <LoadingSpinner size={2} />
      ) : (
        <p
          css={css`
           color: ${labelColor || 'white'};
           font-family: ${
             useAltFontFamily
               ? "'Maison Neue', sans-serif;"
               : "'Rift', sans-serif;"
           }
           font-size: ${small ? '14px' : '18px'};
           font-weight: 500;
         `}
        >
          {label}
        </p>
      )}
    </AntButton>
  )
}
